<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('수행평가 대상') }}</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>{{ $t('부서(업체)명') }}</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            :fieldId="form.stdInfo.field_id"
            v-model="form.inputA_1"
            :placeholder="$t('선택')"
            @select="targetCompany">
          </CompanySelector>
        </div>
        <div>
          <div>{{ $t('피평가자') }}</div>
          <ml-input v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t('평가일') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_3" />
        </div>
      </div>
    </div>

    <table-score
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :is-note="false"
      :is-not-dot-in-label="true"
      :title="'업무 수행 여부'"
      :list="form.scoreList"
      table-header-label="평가항목"
      table-header-content="평가기준"
      table-header-score="배점"
      @update-list-check="updateListCheck"
      @update-value="updateValue"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import TableScore from "@/components/TableScore.vue";

export default {
  components: {
    TableScore,
    PhotoUploadGridModule,
    CompanySelector,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        companyName: "",
        photoList: [],

        inputA_1: '',
        inputA_2: '',
        inputA_3: '',

        score: 0,
        scoreList: [
          {
            id: 1,
            title: '1. 산업재해예방계획 수립(15점)',
            label: '1) 일반원칙',
            content: '안전보건방침 내용의 적정 여부',
            score: 4,
            good: 4,
            normal: 2,
            bad: 0,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 2,
            title: '1. 산업재해예방계획 수립(15점)',
            label: '2) 안전보건목표수립',
            content: '산업재해예방 활동에 대한 이행계획 적정 여부',
            score: 7,
            good: 7,
            normal: 4,
            bad: 1,
            note: '',
            is_checked: '',
          },
          {
            id: 3,
            title: '1. 산업재해예방계획 수립(15점)',
            label: '3) 역할 및 책임, 제정·변경 절차 및 공유의 적정성',
            content: '이행계획 추진을 위한 구성원의 역할 분담, 제정·변경 절차 및 공유의 적정성',
            score: 4,
            good: 4,
            normal: 2,
            bad: 0,
            note: '',
            is_checked: '',
          },

          {
            id: 4,
            title: '2. 안전보건관리규정(8점)',
            label: '1) 일반원칙',
            content: '안전보건관리규정 내용의 적정 여부',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 5,
            title: '2. 안전보건관리규정(8점)',
            label: '2) 안전관리규정 제정·변경 절차',
            content: '규정 제정·변경 절차 및 최신화 관리, 공유의 적정성',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 6,
            title: '3. 안전보건교육(12점)',
            label: '1) 교육계획 수립',
            content: '교육계획 수립의 내실성 및 절차의 적정성',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 7,
            title: '3. 안전보건교육(12점)',
            label: '2) 안전보건교육 실시 수준',
            content: '산업안전보건법에 따른 안전보건교육 실시 수준',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 8,
            title: '3. 안전보건교육(12점)',
            label: '3) 안전보건교육 관리 및 지원',
            content: '교육 참석 제고, 불참자에 대한 추가 교육 등 과정 및 사후관리 적정성',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 9,
            title: '4. 작업환경의 점검 및 개선(8점)',
            label: '1) 작업환경측정 점검',
            content: '작업환경측정 대상여부 파악 및 실시 수준',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 10,
            title: '4. 작업환경의 점검 및 개선(8점)',
            label: '2) 작업환경개선 노력 수준',
            content: '노출기준 초과 공정 작업환경개선 노력',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 11,
            title: '5. 근로자 건강진단 등 건강관리(8점)',
            label: '1) 계획수립',
            content: '건강진단 실시계획 수립',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 12,
            title: '5. 근로자 건강진단 등 건강관리(8점)',
            label: '2) 건강관리',
            content: '건강 이상소견자 파악 및 사후관리',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 13,
            title: '6. 산업재해의 원인조사 및 재발방지 대책 수립(8점)',
            label: '1) 지침서 작성',
            content: '재해 원인조사 지침(절차서 등)의 작성',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 14,
            title: '6. 산업재해의 원인조사 및 재발방지 대책 수립(8점)',
            label: '2) 원인조사 및 재발방지대책 수립',
            content: '원인조사, 재발방지대책 수립 및 공유의 적정성',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 15,
            title: '7. 산업재해에 관한 통계의 기록 및 유지관리에 관한 사항(4점)',
            label: '1) 발생재해 기록 유지관리 및 활용',
            content: '발생재해 기록 유지관리 및 활용의 적정성',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 16,
            title: '8. 안전장치 및 보호구 구입시 적격품 여부 확인에 관한 사항(4점)',
            label: '1) 적격품 확인',
            content: '안전장치 및 보호구 구입시 적격품 여부 확인',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 17,
            title: '9. 위험성평가(20점)',
            label: '1) 절차서 작성',
            content: '위험성평가 절차서 작성',
            score: 10,
            good: 10,
            normal: 6,
            bad: 3,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 18,
            title: '9. 위험성평가(20점)',
            label: '2) 추진 활동',
            content: '위험성평가 추진 활동',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 19,
            title: '9. 위험성평가(20점)',
            label: '3) 위험성평가 결과 활용',
            content: '위험성평가 결과 공유 및 안전보건활동 활용',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 20,
            title: '10. 근로자의 위험 또는 건강장해를 방지에 관한 사항(4점)',
            label: '1) 기준준수',
            content: '｢산업안전보건기준에 관한 규칙｣에서 규정하고 있는 각종 유해 위험 요인에 대한 기준을 준수',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 21,
            title: '11. 안전보건경영 의지표명 및 활동(5점)',
            label: '1) 리더십',
            content: '안전보건경영 의지표명 및 활동',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 22,
            title: '12. 안전보건 예산의 적정 편성 및 집행4점)',
            label: '1) 예산편성 및 집행 적정성',
            content: '안전보건 예산의 적정 편성 및 집행',
            score: 4,
            good: 4,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
        ],
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
    updateListCheck (indexList, text) {
      this.form.scoreList[indexList].is_checked = text
    },
    updateValue (value) {
      this.form.score = value
    },
  },
};
</script>

<style scoped lang="scss">
</style>
